export default (props) => {
    let {
        title,
        textMobile,
        textDesktop,
        textButtonAgree,
        textButtonChange,
        allowChange,
        changeUrl,
        textButtonRefuse,
        allowRefuse,
        useModal,
    } = props;

    // Fallbacks, inheritances
    if (!textMobile && textDesktop) {
        textMobile = textDesktop;
    } else if (textMobile && !textDesktop) {
        textDesktop = textMobile;
    }

    if (!textButtonAgree) {
        textButtonAgree = `Akkoord`;
    }

    if (!textButtonChange) {
        textButtonChange = `Wijzigen`;
    }

    if (!textButtonRefuse) {
        textButtonRefuse = `Weigeren`;
    }

    if (allowChange === undefined) {
        allowChange = true;
    }

    if (allowRefuse === undefined) {
        allowRefuse = false;
    }

    const parentElement = document.createElement(`div`);
    parentElement.innerHTML = `
    <div class="consent-cookiebar" data-modal="${useModal && changeUrl ? "true" : "false"}">
        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="content">
                        ${title ? `<span class="title">${title}</span>` : ``}
                        <div class="text mobile">${textMobile}</div>
                        <div class="text desktop">${textDesktop}</div>
                    </div>
                    <div class="actions">
                        <button class="button" data-agree>
                            <span>${textButtonAgree}</span>
                        </button>
                        ${(allowChange && changeUrl) ? `
                            <a class="button" href="${changeUrl}" data-change>
                                <span>${textButtonChange}</span>
                            </a>
                        ` : ``}
                        ${allowRefuse ? `
                            <button class="button" data-refuse>
                                <span>${textButtonRefuse}</span>
                            </button>
                        ` : ``}
                    </div>
                </div>
            </div>
        </div>
    </div>`;
    return parentElement.firstElementChild;
}